import styled from 'styled-components';
import { parseProp, parseTheme } from 'mol-ui';

export const ErrorMessage = styled.p`
    ${ parseTheme('color', 'dangerColor') }
    font-size: 11px;
    left: 0;
    ${ ({ marginBottom }) => marginBottom ? `margin-bottom: ${ marginBottom }px;` : '' };
    margin-left: ${ ({ marginLeft }) => `${ marginLeft }px` };
    margin-top: ${ ({ marginTop }) => `${ marginTop }px` };
    ${ parseProp('margin') }
    position: ${ ({ relative }) => relative ? 'relative' : 'absolute'  };
    ${ ({ align }) => align ? `text-align: ${ align }` : '' }
`;

ErrorMessage.displayName = 'ErrorMessage';
